import { Events, SportsApiClient } from '@collector/sportsapi-client'

import {
  BaseIncident,
  QueueIncidentError,
  QueueIncidentStatus,
} from './BaseIncident.js'

export type UpdateIncidentPayload = Omit<
  Events.IncidentsQueue.IncidentsQueuePatchPayload,
  'action' | 'event_id'
>

export class UpdateIncident extends BaseIncident {
  readonly type = 'Update'
  readonly isConfirmable = true
  readonly payload: UpdateIncidentPayload
  readonly id: number
  uuid?: string

  constructor(
    eventId: number,
    payload: UpdateIncidentPayload,
    id: number,
    uuid?: string,
    status?: QueueIncidentStatus,
    time?: number,
    error?: QueueIncidentError,
  ) {
    super(eventId, status, time, error)

    this.payload = payload
    this.id = id
    this.uuid = uuid
  }

  public async process(sportsApiClient: SportsApiClient): Promise<string> {
    /**
     * PATCH sends `uuid` re-generated for every request (for better debugging)
     */
    this.uuid = BaseIncident.getUUID()

    const response = await sportsApiClient.Events.IncidentsQueue.patch(
      this.eventId,
      this.uuid,
      this.id,
      {
        incident: {
          ...this.payload,
          event_id: this.eventId,
          action: 'update',
        },
      },
    )

    return response.api.data.uuid
  }
}
